var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"section-label"},[_c('span',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.props.label)+" ")]),_vm._t("label")],2),_c('div',{staticClass:"section-content",attrs:{"id":'section__' +
        _vm.props.label
          .toLowerCase()
          .split(' ')
          .join('-')}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }